import { render, staticRenderFns } from "./Excellent.vue?vue&type=template&id=0f4340bf"
import script from "./Excellent.vue?vue&type=script&lang=js"
export * from "./Excellent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports